import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Icon, styled } from "@mui/material";
import { navigations } from "app/navigations";
import useAuth from "app/hooks/useAuth";
import { navGuard } from "app/auth/navGuard";

// STYLED COMPONENT
const StyledIcon = styled(Icon)(() => ({
  fontSize: "18px",
  verticalAlign: "middle"
}));

export default function MatxHorizontalNav({ max }) {
  const { user } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    let userNavigations = navGuard(navigations, user);
    let updateNavigation = [];
    if (max && userNavigations.length > max) {
      let childItem = {
        name: "More",
        icon: "more_vert",
        children: userNavigations.slice(max, userNavigations.length)
      };

      updateNavigation = userNavigations.slice(0, max);
      updateNavigation.push(childItem);
    }
    setNavItems(updateNavigation)
  }, []);

  function renderLevels(levels) {
    return levels.map((item, key) => {
      if (item.type === "label") return null;

      if (item.children) {
        return (
          <li key={key}>
            <a href="/">
              {item.icon && <StyledIcon>{item.icon}</StyledIcon>}
              {item.name}
            </a>
            <ul>{renderLevels(item.children)}</ul>
          </li>
        );
      } else {
        return (
          <li key={key}>
            <NavLink to={item.path}>
              {item.icon && <StyledIcon>{item.icon}</StyledIcon>}
              {item.name}
            </NavLink>
          </li>
        );
      }
    });
  }

  return (
    <div className="horizontal-nav">
      <ul className="menu">{renderLevels(navItems)}</ul>
    </div>
  );
}
